import cn from 'classnames'

const BackArrowIcon = ({
  className = '',
  color = 'currentColor',
  width = '35',
  height = '35',
}) => {
  return (
    <svg
      className={cn(className)}
      width={width}
      height={height}
      viewBox="0 0 35 35"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.19727 14.9479L24.6424 14.9479C26.9394 14.9479 28.8014 16.81 28.8014 19.1069L28.8014 20.6326C28.8014 22.9296 26.9394 24.7916 24.6424 24.7916L10.2077 24.7916"
        stroke={color}
        strokeWidth="2.08134"
        strokeLinejoin="round"
      />
      <path
        d="M9.84375 10.5729C8.13521 12.2814 7.17729 13.2393 5.46875 14.9479L9.84375 19.3229"
        stroke={color}
        strokeWidth="2.08134"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export default BackArrowIcon
